import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {FormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';
import {ProviderModel} from '../../../../models/ProviderModel';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';

@Component({
  selector: 'app-contract-type-filter',
  templateUrl: './contract-type-filter.component.html',
  styleUrls: ['./contract-type-filter.component.scss']
})
export class ContractTypeFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listContractTypeFilter: any[];
  optionSelected: any;
  formControl: FormControl = new FormControl();
  filteredOptions: BehaviorSubject<ContractTypeModel[]> = new BehaviorSubject<ContractTypeModel[]>([]);

  filterAllSettings: AllSettingsFilterModel;

  @Input() contractTypeData: any;
  @Input() contractTypeSelected: ContractTypeModel;

  @Input() inAllSettings?: boolean;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;
  @Input() sizeForFilterInSettings?: SizeModel;
  @Input() siteForFilterInSettings?: SiteModel;

  @Input() numAnnoMeseFromForFilterInSettings: number;
  @Input() numAnnoMeseToForFilterInSettings: number;

  constructor(private contractTypeService: ContractTypeService) {
    super();
  }

  ngOnInit() {
    this.fetchFilterData();
    this.formControl.setValue(this.contractTypeSelected ? this.contractTypeSelected.cod : null);
    this.formControl.valueChanges
      .subscribe(value => {
        const result = this._filter(value);
        this.filteredOptions.next(result);
        this.dataFiltered.emit(this.filteredOptions.value.find(x => x.cod === value || x.description === value));
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('contractTypeData' in changes) {
      this.listContractTypeFilter = this.contractTypeData;
      this.optionSelected = null;
    }
    if (
      'regionForFilterInSettings' in changes ||
      'localCustomerForFilterInSettings' in changes ||
      'providerForFilterInSettings' in changes ||
      'resourceUnitForFilterInSettings' in changes ||
      'sizeForFilterInSettings' in changes ||
      'siteForFilterInSettings' in changes
    ) {
      this.fetchFilterData();
    }
    if (this.contractTypeSelected || 'contractTypeSelected' in changes) {
      this.optionSelected = this.contractTypeSelected ? this.contractTypeSelected.cod : null;
    }
    this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
  }

  fetchFilterData() {
    if (this.inAllSettings) {
      this.filterAllSettings = new AllSettingsFilterModel(
        this.regionForFilterInSettings,
        this.localCustomerForFilterInSettings,
        this.resourceUnitForFilterInSettings,
        this.providerForFilterInSettings,
        this.contractTypeSelected,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.sizeForFilterInSettings?.cod ? this.sizeForFilterInSettings : null,
        this.siteForFilterInSettings,
        null,
        null,
        null,
        null
      );
      this.contractTypeService.getListInAllSettings(
        this.contractTypeService.baseUrl,
        this.filterAllSettings)
        .subscribe(
          (result: any) => {
            this.listContractTypeFilter = this.contractTypeData = result;
            // this.optionSelected = null;
            this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
          });
    }
  }

  private _filter(value: string): ContractTypeModel[] {
    const filterValue = value ? value.toLowerCase() : '';
    if (!this.contractTypeData) {
      return [];
    }
    return this.contractTypeData.filter(
      option => option.cod.toLowerCase().includes(filterValue) || option.description.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
  }

}
